import Vue from 'vue'
import { Helpers } from 'truefuture-ui'

export default () => {
    // HELPERS
    Object.keys(Helpers).forEach((key) => {
        Vue.prototype['$' + key.toLowerCase()] = Helpers[key]
    }, Helpers)
}